 <mat-sidenav-container class="dashboard-container">
    <!-- Sidebar -->
    <mat-sidenav mode="side" opened class="sidebar">
        <mat-nav-list>
            <!-- Use routerLinkActive="active" to apply the 'active' CSS class when this link is active. -->
            <!-- If you want an exact match for the dashboard route, add [routerLinkActiveOptions]="{ exact: true }" -->
            <mat-list-item routerLink="/dashboard" routerLinkActive="active">
              <mat-icon matListItemIcon>home</mat-icon>
              <div matListItemTitle>Dashboard</div>
            </mat-list-item>
            
            <mat-list-item routerLink="/wallet" routerLinkActive="active" [disabled]="tpi">
              <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
              <div matListItemTitle>Wallet</div>
            </mat-list-item>
            <mat-list-item routerLink="/meter-details" routerLinkActive="active">
              <mat-icon matListItemIcon>speed</mat-icon>
              <div matListItemTitle>Meter Details</div>
            </mat-list-item>
            
            <mat-list-item routerLink="/event-details" routerLinkActive="active">
              <mat-icon matListItemIcon>event</mat-icon>
              <div matListItemTitle>Event Details</div>
            </mat-list-item>
          </mat-nav-list>
          
  
      <div class="sidebar-footer">
        <mat-nav-list>
          <mat-list-item routerLink="/profile" routerLinkActive="active">
            <mat-icon matListItemIcon>person</mat-icon>
            <div matListItemTitle>Profile</div>
          </mat-list-item>
          <mat-list-item (click)="openNewTab('/faq')">
            <mat-icon matListItemIcon>help_outline</mat-icon>
            <div matListItemTitle>Help</div>
            <!-- <a href="/faq" target="_blank" class="text-decoration-none" matListItemTitle>Help</a> -->
          </mat-list-item>
          <mat-list-item (click)="logout()">
            <mat-icon matListItemIcon>exit_to_app</mat-icon>
            <div matListItemTitle>Logout</div>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </mat-sidenav>
  
    <!-- Main content -->
    <mat-sidenav-content class="main-content">
        
        <!-- This is where child pages inside the layout will appear -->
        <router-outlet></router-outlet>
        <!-- <div class="d-flex justify-content-end text-md-primary">Logged in as {{email}}</div> -->
    </mat-sidenav-content>
</mat-sidenav-container>
